"use strict";
// Template version: 1.2.5
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require("path");


module.exports = {
  
  dev: {
    // Paths
    assetsSubDirectory: "static", // 旧 static  new ''
    assetsPublicPath: "/", // 旧 /     new ./
    proxyTable: {
      '/api': {
  target: 'http://localhost:8889/fm',
  changeOrigin: true,

  pathRewrite: {
    '^/api': ''  // 移除 /api 前缀
  }
},
  },
   externals: {
    AMap: 'AMap'
  },
    // Various Dev Server settings
    //  host: "192.168.101.5", // can be overwritten by process.env.HOST
    //  host: "192.168.35.164", // can be overwritten by process.env.HOST
    // host: '192.168.25.182', // can be overwritten by process.env.HOST
    // host: '192.168.25.157', // can be overwritten by process.env.HOST
    // host: "192.168.35.101", // can be overwritten by process.env.HOST
    
     host: '127.0.0.1',
 
    https: true,
    port: 8120, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-
    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: false,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,
    /**
     * Source Maps
     */
    // https://webpack.js.org/configuration/devtool/#development
    devtool: "source-map",

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, "../findMacau/index.html"),
    // Paths
    assetsRoot: path.resolve(__dirname, "../findMacau"),
    assetsSubDirectory: "",
    assetsPublicPath: "./", // 测旧 /
    /**
     * Source Maps
     */
    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: "#source-map",
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ["js", "css"],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  },
  uat: {
    // Template for index.html
    index: path.resolve(__dirname, "../findMacau/index.html"),
    // Paths
    assetsRoot: path.resolve(__dirname, "../findMacau"),
    assetsSubDirectory: "static",
    assetsPublicPath: "./", //  旧: /
    /**
     * Source Maps
     */
    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: "#source-map",
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ["js", "css"],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  }
};



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 87